var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8"},[_c('button',{staticClass:"btn-back",on:{"click":_vm.handleBack}},[_c('v-icon',{staticClass:"fa-solid fa-angle-left"}),_c('span',[_vm._v(_vm._s(_vm.$t('go_back')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }